//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateRandomEntry, generateRandomEntries } from '../utils/chat.utils'
import chatXss from './chat-list-xss'
export default {
  name: 'chat-feed',
  data () {
    return {
      messages: generateRandomEntries(1),
      currentMessage: ''
    }
  },
  methods: {
    addEntryToChat: function (malicious) {
      const randomMessage = generateRandomEntry(malicious)
      this.messages.push(randomMessage)
      this.currentMessage = randomMessage
    }
  },
  components: {chatXss}
}



// WEBPACK FOOTER //
// ./src/components/chat-feed.vue